// extracted by mini-css-extract-plugin
export default {"btn":"ss_btn__49WHw","select":"ss_select__IRAgU","input_wrapper":"ss_input_wrapper__QYySq","input":"ss_input__n+frq","icon":"ss_icon__VTsbP"};